<div class="container">
  <div class="row">
   <section class="col-md-7">
    <app-risk-flow-top-tips
      [config]="{
        consumerId: 'GC',
        flow: 'CWP',
        clientType: 'CLIENT'
      }"
      (errorHandler)="errorHandler($event)"
    >
    </app-risk-flow-top-tips> 
    <vgim-secure-link></vgim-secure-link>
    </section>
    <div class="col-md-1"></div>
      <section class="col-md-4">
        <c11n-button id="riskQuizSetupContinueBTN" [labelText]="openChoiceCommonContent.continueButton" [fullWidth]="true"
          (clickEvent)="continue()"></c11n-button>
        <app-cancel [isOpenChoice]="true"></app-cancel>
        <app-feedback-survey></app-feedback-survey>
      </section>
  </div>
</div>